import { Component, Input, Output, EventEmitter, OnChanges, OnInit} from '@angular/core';
import moment from 'moment';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { KeyFilterModule } from 'primeng/keyfilter';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';

@Component({
    selector: 'input-date',
    templateUrl: './input-date.component.html',
    standalone: true,
    imports: [FormsModule,
      NgClass,
      InputNumberModule,
      KeyFilterModule,
      AfTranslatePipe
    ]
})
export class InputDateComponent implements OnInit, OnChanges {
  isLanding: boolean = this.customLanding.isLanding();
  inputDate: any = {
    day: '',
    month: '',
    year: '',
    hours: '',
    minutes: '',
    date: [],
    inputId: this.commonUtilsService.createId()
  };

  @Input() input: any;
  @Input() disabled: any;
  @Input() field: any;
  @Output() output = new EventEmitter();

  constructor(private customLanding: CustomLandingFactory,
    private commonUtilsService: CommonUtilsService
  ) { }

  ngOnChanges() {
    let that = this.inputDate;
    if (this.input && moment(this.input).isValid()) {
      let date = moment(this.input).format('DD-MM-YYYY HH:mm').split(' ');
      let dateFirst = date[0].split('-');
      let dateTime = date[1].split(':');
      that.day = dateFirst[0];
      that.month = dateFirst[1];
      that.year = dateFirst[2];
      that.hours = dateTime[0];
      that.minutes = dateTime[1];
      that.error = false;
    } else if (!this.input) {
      this.configureDefaultDate();
    }
  }

  ngOnInit() {
    // this.inputDate.sequentialView = this.field && this.field.poll && !this.field.noEditable && this.field.sequentialView && this.isLanding;
  }

  configureDefaultDate(){
    let that = this.inputDate;
    that.day = '';
    that.month = '';
    that.year = '';
    that.hours = '';
    that.minutes = '';
  }

  validateInputDate(type:string, e:any){
    if(!isNaN(parseInt(e.key))){
      let that = this.inputDate;
      switch (type){
        case 'day':
          let day: any = parseInt(that.day);
          if(day > 3 || that.day.length === 2){
            let maxDay: any = this.checkMaxDayMonth();
            that.day = day < 9? '0' + day : day > maxDay ? maxDay : that.day;
            this.validateDateForm();
            let inputMonth: any = document.getElementById('input-date-month-' + this.inputDate.inputId);
            inputMonth.focus();
            inputMonth.select();
          }
          break;
        case 'month':
          let month: any = parseInt(that.month);
          if(month > 2 || that.month.length === 2){
            that.month = month < 9? '0' + month : month > 12 ? 12 : that.month;
            that.day = this.configureSelectedDay();
            this.validateDateForm();
            let inputYear: any = document.getElementById('input-date-year-' + this.inputDate.inputId);
            inputYear.focus();
            inputYear.select();
          }
          break;
        case 'year':
          if(that.year.length === 4){
            if(parseInt(that.year) > 2100){
              that.year = '2100';
            }else if(parseInt(that.year) < 1900){
              that.year = '1900';
            }
            that.day = this.configureSelectedDay();
            this.validateDateForm();
            if(this.field?.showTime) {
              let inputHour: any = document.getElementById('input-date-hour-' + this.inputDate.inputId);
              inputHour.focus();
              inputHour.select();
            }else{
              let inputYear: any = document.getElementById('input-date-year-' + this.inputDate.inputId);
              inputYear.blur();
            }
          }
          break;
        case 'hours':
          let hours: any = parseInt(that.hours);
          if(hours > 3 || that.hours.length === 2){
            that.hours = hours < 9? '0' + hours : hours > 23 ? 23 : that.hours;
            this.inputDate.validatedTime = true;
            this.validateDateForm();
            let inputMinute: any = document.getElementById('input-date-minute-' + this.inputDate.inputId);
            inputMinute.focus();
            inputMinute.select();
          }
          break;
        case 'minutes':
          let minutes: any = parseInt(that.minutes);
          if(minutes > 5 || that.minutes.length === 2){
            that.minutes = minutes < 9? '0' + minutes : that.minutes;
            this.inputDate.validatedTime = true;
            this.validateDateForm();
            let inputMinute: any = document.getElementById('input-date-minute-' + this.inputDate.inputId);
            inputMinute.blur();
          }
          break;
      }
    }
  }

  checkMaxDayMonth(){
    if(this.inputDate.month){
      let month: any = parseInt(this.inputDate.month);
      let year: any = new Date().getFullYear();
      if(this.inputDate.year){
        year = parseInt(this.inputDate.year);
      }
      return new Date(year, month, 0).getDate().toString();
    }else{
      return '31';
    }
  }

  configureSelectedDay(){
    let day: any = this.checkMaxDayMonth();
    return parseInt(this.inputDate.day) > day?day:this.inputDate.day;
  }

  blurInputTime(type: any = 'hours'){
    if(!this.inputDate.validatedTime){
      let typePicker : any = parseInt(this.inputDate[type]);
      if(!typePicker){
        this.inputDate[type] = '00';
      }
      this.validateDateForm();
    }else{
      delete this.inputDate.validatedTime;
    }
  }

  validateDateForm(){
    let isValid = this.checkIsValidDate();
    if(this.validateDate()){
      this.inputDate.error = false;
      let newDate: any = this.inputDate.month + '/' + this.inputDate.day + '/' + this.inputDate.year;
      if(this.field?.showTime){
        newDate += ' ' + this.inputDate.hours + ':' + this.inputDate.minutes;
      }
      if (!moment(newDate, 'MM/DD/YYYY', true).isValid() && !moment(newDate, 'MM/DD/YYYY HH:mm', true).isValid()) {
        isValid = false;
      }
      this.output.emit({value: newDate, isValid: isValid});
    }
  }

  validateDate(){
    let validateDay = this.inputDate.day.length === 2;
    let validateMonth = this.inputDate.month.length === 2;
    let validateYear = this.inputDate.year.length === 4;
    let validateTime = true;
    if(this.field?.showTime){
      validateTime = this.inputDate.hours && this.inputDate.minutes;
    }
    return validateDay && validateMonth && validateYear && validateTime;
  }

  checkIsValidDate() {
    let that = this.inputDate;
    let isValid = Boolean(that.month && that.day && that.year) && moment(that.month + '/' + that.day + '/' + that.year + ' ' + that.hours + ':' + that.minutes).isValid();
    let isValidDateLockType: boolean = true;
    if(isValid && this.field?.dateLockType){
      let todayDate = moment().format('MM-DD-YYYY');
      let selectedDate = that.month+'-'+that.day+'-'+that.year;
      switch (this.field?.dateLockType) {
        case 1:
          isValidDateLockType = !(moment(selectedDate).isBefore(todayDate));
          break;
        case 2:
          isValidDateLockType = !(moment(selectedDate).isBefore(todayDate) || (moment(selectedDate).isSame(todayDate)));
          break;
        case 3:
          isValidDateLockType = !(moment(selectedDate).isAfter(todayDate));
          break;
        case 4:
          isValidDateLockType = !(moment(selectedDate).isAfter(todayDate) || (moment(selectedDate).isSame(todayDate)));
          break;
        default:
          isValidDateLockType = true;
          break;
      }
    }
    return isValid && isValidDateLockType;
  }
}
